import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { Paper, RaisedButton } from 'material-ui';

const { func, string } = PropTypes;

const QuickLinksItem = ({ buttonText, disabled, icon, primaryText, routeName, onClick, secondaryText, style }) => (
  <Paper style={Object.assign({}, { padding: '30px', textAlign: 'center' }, style, disabled && { position: 'relative' })}>
    <img src={icon} />
    <div style={{ padding: '10px 0' }}>
      <p style={{ margin: 0, padding: 0 }}>{primaryText}</p>
      <p style={{ margin: 0, padding: 0 }}>{secondaryText}</p>
    </div>
    <Link to={routeName} onClick={onClick}>
      <RaisedButton primary label={buttonText} />
    </Link>
  </Paper>
);

QuickLinksItem.propTypes = {
  buttonText: string.isRequired,
  icon: string.isRequired,
  onClick: func,
  primaryText: string.isRequired,
  secondaryText: string,
  routeName: string.isRequired,
};

export default QuickLinksItem;



// WEBPACK FOOTER //
// ./src/app/components/dashboard/QuickLinksItem.jsx